import fundayImage from '../images/homepagePics/fourthFundayFlyer.png';
export const EventInfo= [
    {
        showDetails: false,
        title: '4th Annual Family Mental Health Funday',
        image: fundayImage,
     }
];